import { dispatchError, OtDispatch, OtStoreState } from '@react/redux/store'
import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'
import { ActivityEnum } from '@shared/Enums'

import { chainActions } from '@react/redux/chainSlice'

import { poolActions } from '@react/redux/poolSlice'
import { ChainConfiguration, StageConfiguration, convertToAppKitNetwork } from '@shared/DeploymentConfigs'
import { logOT } from '@shared/loggingShared'
import { ethers, Network } from 'ethers'
import { fetchChainTimestampDelta } from './fetchChainTimestampDeltaTx'
import { fetchPerimeterAddresses } from './fetchPerimeterAddressesTx'

export const connectToChainThunk =
  (props: {
    chainConfigurationName: string
    switchNetwork: (network: any) => void
  }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const { chainConfigurationName, switchNetwork } = props

    logOT.info('connectToChainThunk START', chainConfigurationName)
    try {
      logOT.info('connectToChainThunk chainState', chainConfigurationName)
      const stageConfiguration = getState().chainState.stageConfiguration
      const { chainConfigurations, restAPIKey, serverApiBaseUrl, isLyt } = stageConfiguration as StageConfiguration

      const chainConfiguration = chainConfigurations.find(
        (chainConfig) => chainConfig.chainConfigurationName === chainConfigurationName
      )
      if (!chainConfiguration) {
        throw new Error('chainConfiguration not found')
      }

      const appKitNetwork = convertToAppKitNetwork(chainConfiguration)
      logOT.info('connectToChainThunk NETWORK SWITCH  connectToChainThunk', appKitNetwork)
      await switchNetwork(appKitNetwork as any)

      logOT.info('connectToChainThunk chainState', chainConfiguration)
      await connectToChain(chainConfiguration)

      const providerReadOnly = new ethers.JsonRpcProvider(
        chainConfiguration.frontendProviderUrl,
        new Network(chainConfiguration.chainName, chainConfiguration.chainId),
        {
          staticNetwork: true,
          pollingInterval: 100,
          polling: false,
          batchMaxCount: 1,
        }
      )
      const chainTimestampDelta = await fetchChainTimestampDelta(providerReadOnly)
      logOT.trace('connectToChainThunk chainTimestampDelta', chainTimestampDelta)

      const perimeterAddresses = await fetchPerimeterAddresses(chainConfiguration, serverApiBaseUrl, restAPIKey, isLyt)
      logOT.trace('connectToChainThunk perimeterAddresses', perimeterAddresses)
      dispatch(
        chainActions.connectChainConfiguration({
          chainConfiguration,
          providerReadOnly,
          chainTimestampDelta,
          perimeterAddresses,
        })
      )

      dispatch(poolActions.finishedInitializing())
      logOT.info('connectToChainThunk finishedInitializing')
    } catch (e: any) {
      await dispatchError(dispatch, e, ActivityEnum.DEPLOYMENT_CONFIGURATION, 1022)
    }
  }

export const jestReactConnectToChain = async (_dispatch: OtDispatch, _chainConfigurationName: string) => {
  logOT.info('jestReactAttachToDeployment START')
  throw new Error('jestReactAttachToDeployment not implemented')
}

async function connectToChain(chainConfiguration: ChainConfiguration): Promise<ChainConfiguration> {
  logOT.info('connectToChain  SET chainConfigurationName', chainConfiguration.chainConfigurationName)

  localStorage.setItem('chainConfigurationName', chainConfiguration.chainConfigurationName)

  if (!chainConfiguration) {
    throw new Error('chainConfiguration not found')
  }
  return chainConfiguration
}
